<template>
  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("chemicals.metaTitle")) }}</title>
      <meta name="title" :content="changeMetatagHtml($t('chemicals.metaTitle'))">
      <link rel="canonical" href="https://komatools.com/es/quimicos"/>
      <link rel="alternate" href="https://komatools.com/es/quimicos" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/chemicals" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/produits-chimiques" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/quimicos" hreflang="x-default"/>

      <meta name="description" :content="changeMetatagHtml($t('chemicals.metaDescription'))">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('chemicals.metaTitle'))">
      <meta property="og:description" :content="changeMetatagHtml($t('chemicals.metaDescription'))">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('chemicals.metaTitle'))">
      <meta property="twitter:description" :content="changeMetatagHtml($t('chemicals.metaDescription'))">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>
    <div class="section light paddingBigger">
      <div>
        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("chemicals.title") }}</h1>
            <h2 v-html="$t('chemicals.subTitle')" class="subTitle"></h2>
          </div>
        </div>
        <details>
          <summary v-html="$t('chemicals.summary.title')"></summary>
          <p v-html="$t('chemicals.summary.descriptionParagraph1')"></p>
          <p v-html="$t('chemicals.summary.descriptionParagraph2')"></p>
          <p v-html="$t('chemicals.summary.descriptionParagraph3')"></p>
        </details>

        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
                        <span
                            @click="filterData(filter)"
                            :class="{ active: filter === activeFilter }"
                        >{{ $t(filter.text) }}</span>
          </a>
        </div>
        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>
        <div v-else>
          <ArticlesList :articles="searchedArticles"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import getArticles from '../../composables/getArticles'
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from '@/components/ArticlesList.vue'
import {Head} from '@vueuse/head'
import {computed, ref} from 'vue'
import {useRoute} from "vue-router";

// Composition API and external JS
export default {
  name: "Chemicals",
  components: {ArticlesList, Head},
  setup() {
    const route = useRoute();

    const subcategories = [
      'ELK11B0105',
      'ELK11B0111',
      'ELK11B0113',
      'ELK210A100',
      'ELK210A111',
      'ELK21AA04',
      'ELK21AA15',
      'ELK12AA0020',
      'ELK210A050',
      'ELK210A100',
      'ELK210A111',
      'ELK23BC970',
      'ELK15A45',
      'ELK15A055'
    ]

    const filterMap = {
      all: 0,
      adhesives: 1,
      paintsEnamelAndTreatments: 2,
      lubricants: 3,
      industrialCleaning: 4
    }

    const filtersRef = ref([
      {text: 'filtersArticles.all.text', code: []},
      {text: 'filtersArticles.adhesives.text', code: ['ELK11B0111', 'ELK11B0113', 'ELK11B0105', 'ELK11B0111']},
      {text: 'filtersArticles.paintsEnamelAndTreatments.text', code: ['ELK210A100', 'ELK210A111', 'ELK210A111', 'ELK210A100', 'ELK210A050', 'ELK12AA0020']},
      {text: 'filtersArticles.lubricants.text', code: ['ELK21AA04', 'ELK21AA15']},
      {text: 'filtersArticles.industrialCleaning.text', code: ['ELK23BC970']},
    ])
    const activeFilter = ref(filtersRef.value[0]);

    const filterFromRoute = filterMap[route.query.filter];
    if (filterFromRoute) {
      activeFilter.value = filtersRef.value[filterFromRoute];
    }

    const {articles, error, load} = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories)

    load()

    /**
     * This is a function to remove the special character | from javascript
     * More information: https://stackoverflow.com/questions/5796718/html-entity-decode
     */
    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;

    }

    const searchedArticles = computed(() => {
      const activeCodes = Array.isArray(activeFilter.value?.code) ? activeFilter.value.code : [];

      if (activeCodes.length === 0) {
        return articles.value;
      }

      return articles.value.filter((article) =>
          activeCodes.includes(article.subcategoryCode)
      );
    });

    const filterData = (filter) => {
      activeFilter.value = filter;
    }

    return {
      searchedArticles,
      filtersRef,
      activeFilter,
      error,
      GENERIC_VARIABLES,
      subcategories,
      changeMetatagHtml,
      filterData
    }
  }
}
</script>
